<header class="cr-header">
  <div class="cr-header__inner">

    <!-- Logo -->
    <a routerLink="/" class="cr-header__logo" aria-label="Craftly Startseite">
      <svg class="cr-logo__mark" width="26" height="26" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 4 L4 20 L20 20" stroke="currentColor" stroke-width="2.6" stroke-linecap="square" fill="none"/>
        <circle cx="4" cy="4" r="1.8" fill="currentColor"/>
        <path d="M8 20 L8 17 M12 20 L12 16 M16 20 L16 17" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" opacity="0.55"/>
      </svg>
      <span class="cr-logo__wordmark">craftly</span>
    </a>

    <!-- Desktop Navigation -->
    <!-- S1: „Suchen" = geführter Flow (primär), „Betriebe durchsuchen" = Directory (sekundär). -->
    <nav class="cr-header__nav" aria-label="Hauptnavigation">
      <a routerLink="/anfrage/neu" routerLinkActive="cr-header__nav-link--active" class="cr-header__nav-link">Suchen</a>
      <a routerLink="/suche" routerLinkActive="cr-header__nav-link--active" class="cr-header__nav-link">Betriebe durchsuchen</a>
      <a routerLink="/registrieren/handwerker" routerLinkActive="cr-header__nav-link--active" class="cr-header__nav-link">Handwerker werden</a>
      <a routerLink="/hilfe" routerLinkActive="cr-header__nav-link--active" class="cr-header__nav-link">Hilfe</a>
    </nav>

    <!-- Desktop Actions -->
    <div class="cr-header__actions">
      @if (authService.currentUser$ | async; as user) {
        @if (hasDashboard()) {
          <a routerLink="/dashboard" routerLinkActive="cr-header__dashboard-btn--active" class="cr-header__dashboard-btn">
            @if (isHandwerker()) {
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>
            } @else {
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>
            }
            <span>{{ dashboardLabel() }}</span>
          </a>
        }
        <app-notifications-bell />
        <div class="cr-header__user">
          <p-menu #menu [model]="userMenuItems()" [popup]="true" />
          <button class="cr-header__avatar-btn" (click)="menu.toggle($event)" aria-haspopup="true" aria-label="Benutzermenü">
            @if (user.avatarUrl) {
              <img class="cr-header__avatar-img" [src]="user.avatarUrl" alt="" />
            } @else {
              <span class="cr-header__avatar-initial">{{ initial() }}</span>
            }
            <span class="cr-header__vorname">{{ user.vorname ?? user.email }}</span>
            <svg class="cr-header__chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>
          </button>
        </div>
      } @else {
        <p-menu #loginMenu [model]="loginMenuItems" [popup]="true" />
        <button class="cr-btn cr-btn--secondary cr-btn--sm" (click)="loginMenu.toggle($event)">
          Anmelden
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>
        </button>
        <p-menu #registerMenu [model]="registerMenuItems" [popup]="true" />
        <button class="cr-btn cr-btn--dark cr-btn--sm" (click)="registerMenu.toggle($event)">
          Registrieren
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>
        </button>
      }
    </div>

    <!-- Mobile User Icon -->
    <div class="cr-header__mobile-actions">
      @if (authService.currentUser$ | async; as user) {
        @if (hasDashboard()) {
          <a routerLink="/dashboard" class="cr-header__icon-btn" [attr.aria-label]="isHandwerker() ? 'Mein Bereich' : 'Meine Anfragen'">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.6-7 8-7s8 3 8 7"/></svg>
          </a>
        }
      } @else {
        <a routerLink="/login" class="cr-header__icon-btn" aria-label="Anmelden">
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><path d="m10 17 5-5-5-5"/><path d="M15 12H3"/></svg>
        </a>
      }
      <button class="cr-header__icon-btn" (click)="openMobileMenu()" aria-label="Menü öffnen">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 6h16M4 12h16M4 18h16"/></svg>
      </button>
    </div>
  </div>
</header>

<!-- Mobile Drawer -->
<p-drawer [(visible)]="mobileMenuOpen" position="right" header="craftly">
  <nav class="cr-mobile-nav" aria-label="Mobile Navigation">
    <a routerLink="/anfrage/neu" class="cr-mobile-nav__link" (click)="closeMobileMenu()">Suchen</a>
    <a routerLink="/suche" class="cr-mobile-nav__link" (click)="closeMobileMenu()">Betriebe durchsuchen</a>
    <a routerLink="/registrieren/handwerker" class="cr-mobile-nav__link" (click)="closeMobileMenu()">Handwerker werden</a>
    <a routerLink="/hilfe" class="cr-mobile-nav__link" (click)="closeMobileMenu()">Hilfe</a>
    <div class="cr-mobile-nav__divider"></div>
    @if (authService.currentUser$ | async; as user) {
      @if (isHandwerker()) {
        <a routerLink="/dashboard" class="cr-mobile-nav__link" (click)="closeMobileMenu()">Mein Bereich</a>
      } @else if (isEndkunde()) {
        <a routerLink="/dashboard" class="cr-mobile-nav__link" (click)="closeMobileMenu()">Meine Anfragen</a>
        <a routerLink="/anfrage/neu" class="cr-mobile-nav__link cr-mobile-nav__link--primary" (click)="closeMobileMenu()">Neue Anfrage stellen</a>
      }
      <a routerLink="/konto" class="cr-mobile-nav__link" (click)="closeMobileMenu()">Mein Konto</a>
      <button class="cr-mobile-nav__link cr-mobile-nav__link--btn" (click)="authService.logout(); closeMobileMenu()">Abmelden</button>
    } @else {
      <a routerLink="/login" class="cr-mobile-nav__link" (click)="closeMobileMenu()">Anmelden (Kunde)</a>
      <a routerLink="/login/handwerker" class="cr-mobile-nav__link" (click)="closeMobileMenu()">Anmelden (Handwerker)</a>
      <a routerLink="/registrieren" class="cr-mobile-nav__link cr-mobile-nav__link--primary" (click)="closeMobileMenu()">Konto erstellen</a>
      <a routerLink="/registrieren/handwerker" class="cr-mobile-nav__link" (click)="closeMobileMenu()">Betrieb anmelden</a>
    }
  </nav>
</p-drawer>
